export default {"src":"/_next/static/image/public/images/profile_active.2832a0c4c7c26e3136a81a22e198fc44.svg","height":62,"width":120};